import { UserRole } from '../../models';
import { FetchContext, responseErrorHandler } from '..';

export const getUserImpersonationRoles: (
  fetchContext: FetchContext,
  accessToken?: string,
) => Promise<UserRole[]> = (fetchContext, accessToken) => fetch(`${fetchContext.baseUrl}/api/admin/user-impersonations/roles`, {
    method: 'GET',
    headers: {
      'Authorization': `Bearer ${accessToken}`,
      'Content-Type': 'application/json',
    },
  })
  .then((response) => responseErrorHandler<UserRole[]>(fetchContext.errorStore, response, 'get user impersonation roles'));
